import { Link } from 'react-router';
import { Plus } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface CreateAudienceButtonProps {
  tenantSlug: string;
  className?: string;
}

export function CreateAudienceButton({
  tenantSlug,
  className,
}: CreateAudienceButtonProps) {
  const { LL } = useI18nContext();

  return (
    <Button asChild className={cn('shrink-0', className)}>
      <Link to={`/${tenantSlug}/audiences/create`}>
        <Plus data-icon="inline-start" />
        {LL.audiences.createAudienceButton()}
      </Link>
    </Button>
  );
}
